



























import {Component, Prop, Vue} from 'vue-property-decorator';
import {IPxError} from "@/lib/util/errors";
import {allStores} from "@/store/store";

@Component
export default class ErrorDisplay extends Vue {

  @Prop({default: false}) verbose!: boolean;

  get show(){
    return this.newHttpErrors.length > 0
  }

  get newHttpErrors() {
    let e: IPxError[] = [];
    allStores.forEach(s => {
      // const viewed = s.httpErrors.filter(a => a.viewed);
      // const unviewed = s.httpErrors.filter(a => !a.viewed);
      // e = e.concat(unviewed);
      // unviewed.forEach(a => a.viewed = true)
      e = e.concat(s.httpErrors);
    });
    return e
  }

// unviewedErrors : IPxError[] = [];

// mounted(){
//   this.httpErrors.forEach(E => {
//     if (E.viewed === false){
//       this.unviewedErrors.push(JSON.parse(JSON.stringify(E)))
//       E.viewed = true;
//     }
//   })
// }


}
